import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '../table_cell';

const DetailsCell = (props) => (
  <TableCell contentClassName="lbv2__details-cell-content" {...props} />
);

DetailsCell.propTypes = TableCell.propTypes;

export default DetailsCell;
